export const PORTAL_NAME = "DEVELOPER";
export const PORTAL_VERSION = "BETA";
